import api from '@/utils/interceptor'

//关键词查询
export const openPage = params => {
  return api.post('/cms/fe/article/openPage', params)
}

//内容详情
export const infoArticle = params => {
  return api.post('/cms/fe/article/info', params)
}

//用户信息
export const userInfo = ()=>{
  return api.get('/ua/fe/user/info')
}

//退出登录
export const logout = ()=>{
  return api.post('/ua/fe/auth/logout')
}